import { NgModule } from '@angular/core';
import { LibFillTickRoundIconComponent } from './lib-fill-tick-round-icon.component';

@NgModule({
  declarations: [LibFillTickRoundIconComponent],
  exports: [LibFillTickRoundIconComponent],
})
export class LibFillTickRoundIconModule {}
